import {Moment} from 'moment';

export interface DashboardDateRange {
  startDate: Moment;
  endDate: Moment;
}

export enum TopicRollupDateRange {
  LastMonth = 'Last Month',
  Last3Months = 'Last 3 Months',
  LastQuarter = 'Last Quarter',
}
